// Core
import styled from 'styled-components';

// Types
import { Theme } from '../../types/theme';

// Component
import { StatusDotProps, StatusDotStatus } from './StatusDot.types';

/*
  Maps the background color based on the status
  @param theme should receive the theme object
*/
const mapColorByStatus = (theme: Theme) => ({
  [StatusDotStatus.online]: theme.color.statusDot.onlineColor,
  [StatusDotStatus.offline]: theme.color.statusDot.offlineColor,
});

export const Dot = styled.div<Pick<StatusDotProps, 'status'>>`
  width: 9px;
  height: 9px;
  min-width: 9px;
  min-height: 9px;
  border-radius: 50%;
  background-color: ${({ status, theme }) => mapColorByStatus(theme)[status]};
  transition: background-color 0.3s ease;
`;
